import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Logo from './Logo';

class Navegacao extends Component {

  render() {
    const link = this.props.link;
    const titulo = this.props.titulo;

    return(
          <nav className="navigation">
          <section className="container">
            <h1 className="title">
              { link != null && 
              <Link to={link}>
                <span className="fa fa-chevron-left"> </span>
              </Link>}
              {titulo ? titulo : "Central do Cliente"}
              { link != null && 
              <Link to="/"><Logo height="48" /></Link>
              }
            </h1>
          </section>
          </nav>

        );
    }
}

export default Navegacao;